import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const className = sessionStorage.getItem("className");
  const Class9FeesRoute = '/secondary-accounts-fees-structure-class-ix';
  const Class10FeesRoute = '/secondary-accounts-fees-structure-class-x';
  const feesRoute = className === "CLASS_9" ? Class9FeesRoute : className === "CLASS_10" ? Class10FeesRoute : "";
  const Class9DashboardRoute = '/secondary-accounts-dashboard-class-ix';
  const Class10DashboardRoute = '/secondary-accounts-dashboard-class-x';
  const dashboardRoute = className === "CLASS_9" ? Class9DashboardRoute : className === "CLASS_10" ? Class10DashboardRoute : "";


  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">

        <li className={`nav-item ${location.pathname === dashboardRoute ? "active" : ""}`}>
          <a
            className="nav-link"
            href="accounts-dashboard"
            onClick={(e) => {
              e.preventDefault();
              if (dashboardRoute) navigate(dashboardRoute);
            }}
          >
            <i className="icon-grid menu-icon" />
            <span className="menu-title">Class {className === "CLASS_9" ? "IX" : className === "CLASS_10" ? "X" : ""} Dashboard</span>
          </a>
        </li>

        {/* <li className={`nav-item ${location.pathname === "/secondary-accounts-reports" ? "active" : ""}`}>
          <a
            className="nav-link"
            href="accounts-dashboard"
            onClick={(e) => {
              e.preventDefault();
              navigate("/secondary-accounts-reports");
            }}
          >
            <i className="fa fa-file menu-icon" />
            <span className="menu-title">
              Class {className === 'CLASS_9' ? 'IX' : className === 'CLASS_10' ? 'X' : ''} Reports
            </span>
          </a>
        </li> */}

        <li className={`nav-item ${location.pathname === feesRoute ? "active" : ""}`}>
          <a
            className="nav-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (feesRoute) navigate(feesRoute);
            }}
          >
            <i className="fa fa-inr menu-icon" />
            <span className="menu-title">
              Class {className === "CLASS_9" ? "IX" : className === "CLASS_10" ? "X" : ""} Fees Structure
            </span>
          </a>
        </li>



      </ul>
    </nav>
  );
}

export default Sidebar;